'use client';

import { useEffect, useState } from 'react';

export default function useWindow() {
  const [_window, setWindow] = useState<Window & typeof globalThis>();

  useEffect(() => {
    if (typeof window !== 'undefined') setWindow(window);
  }, []);

  return _window;
}
